export default "/images/bank.png?97f7c0f1e3070527dc2be64a6bf29127";